export default class DataManager {

  static memId;
  static userId;
  static sessionId;
  static chatId;

}